// Static site config — wire these to actual values to update content site-wide.
export const SITE = {
  name: "J.J. Botelho",
  fullName: "J.J. Botelho",
  tagline: "Realtor & Mortgage Advisor on Florida's Emerald Coast.",
  phone: "850.797.2673",
  phoneHref: "tel:+18507972673",
  emails: {
    realty: "jjb@coastalrealtyservices.com",
    mortgage: "jj.botelho@edgehomefinance.com",
  },
  affiliations: {
    realty: "Coastal Realty Services",
    mortgage: "Edge Home Finance",
  },
  licenses: {
    realEstate: "FL Real Estate License #3615190",
    nmls: "NMLS #1880512",
  },
  region: "Okaloosa, Walton & Santa Rosa Counties, FL",
  realEstateCounties: ["Okaloosa County", "Walton County", "Santa Rosa County"],
  mortgageCoverage: "Licensed to lend in all 50 U.S. states",
  mortgageProducts: [
    "Conventional",
    "FHA",
    "VA",
    "Jumbo",
    "DSCR (Investor)",
    "Bank Statement Loans",
    "HELOC",
    "Non-QM",
  ],
  mortgageApplyUrl: "https://edgehomefinance.com/team-member/jj-botelho/",
  homeBuyingUrl: "https://www.roomvu.com/services/page/home-buying?agent_profile_name=jj-botelho-2",
  homeSellingUrl: "https://www.roomvu.com/estimates?branded-user=jj-botelho-2&share=true&c=2026-05-21",
  homesAgentUrl: "https://www.homes.com/real-estate-agents/jj-botelho/b4jxb9c/",
  book: {
    url: "https://book-branding-tool.emergent.host/",
    title: "Moving to Florida",
    subtitle: "Emerald Coast Relocation Guide",
    edition: "2026 Edition",
    description:
      "A hyperlocal comparison of six premier Florida Panhandle communities on Florida's Emerald Coast — real prices, real schools, real insider tips. Engineered to help you make a confident, data-backed move.",
    bullets: [
      "Six premier Florida Panhandle cities, side-by-side",
      "Current price trends + what your dollar buys",
      "School ratings, commutes, and lifestyle fit",
      "Insider tips you won't find on Zillow",
    ],
    cta: "Unlock the Free Guide",
  },
  logos: {
    coastalRealty:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/0v8m4kbx_Screenshot%202024-10-09%20200911.png",
    edgeHomeFinance:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/7ydwgg7z_Edge%20Logo.jpg",
  },
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/6794823/pexels-photo-6794823.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  headshot:
    "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/sd4zekqr_504133393_10213403042907288_8298389075975419070_n.jpg",
  realEstate:
    "https://images.pexels.com/photos/276508/pexels-photo-276508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  mortgage:
    "https://images.unsplash.com/photo-1769737122085-97b1ee5ab104?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb2FzdGFsJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTMwODc5MHww&ixlib=rb-4.1.0&q=85",
};

export const AREAS = [
  {
    name: "Destin",
    county: "Okaloosa",
    blurb: "Sugar-white sand, world-class waterfront, and Florida's Emerald Coast marquee buy.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/View_of_Destin%2C_Florida_from_the_Destin_Harbor.jpg/1920px-View_of_Destin%2C_Florida_from_the_Destin_Harbor.jpg",
  },
  {
    name: "Fort Walton Beach",
    county: "Okaloosa",
    blurb: "A coastal town with deep roots — family-friendly, value-rich, walkable. My hometown.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Sunrise_Fort_Walton_Beach_19_January_2014_-_Bridge.jpg/1920px-Sunrise_Fort_Walton_Beach_19_January_2014_-_Bridge.jpg",
  },
  {
    name: "Niceville",
    county: "Okaloosa",
    blurb: "Quiet waterfront living on Boggy Bayou — top schools and steady appreciation.",
    image:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/3k6szk0a_niceville-waterfront.jpg",
  },
  {
    name: "Crestview",
    county: "Okaloosa",
    blurb: "Growing inland community with great value, new builds, and easy commutes.",
    image:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/dtwbo0ef_Crestview.jpg",
  },
  {
    name: "Navarre",
    county: "Santa Rosa",
    blurb: "Home of Florida's longest fishing pier and some of the most uncrowded sand on the Gulf.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Navarre_Beach_Pier_IGP2095.jpg/1920px-Navarre_Beach_Pier_IGP2095.jpg",
  },
  {
    name: "30A",
    county: "Walton",
    blurb: "Seaside, WaterColor, Rosemary Beach — designer beach towns along scenic Highway 30A.",
    image:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/90gs1rns_30a.jpeg",
  },
  {
    name: "Freeport",
    county: "Walton",
    blurb: "One of Florida's fastest-growing cities — Hammock Bay, new construction, bay access.",
    image:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/cz1bf4q8_Freeport.jpg",
  },
  {
    name: "DeFuniak Springs",
    county: "Walton",
    blurb: "Historic Walton County seat — Victorian district circling spring-fed Lake DeFuniak.",
    image:
      "https://customer-assets.emergentagent.com/job_botelho-mortgage-pro/artifacts/yluf73a2_defuniak.jpg",
  },
];

export const REVIEWS = {
  source: "Google Reviews",
  profileUrl: "https://www.google.com/search?q=J.J.+Botelho+Realtor+Okaloosa+County",
  aggregate: {
    rating: 5.0,
    count: 10,
  },
  items: [
    {
      author: "Tony Esposito",
      badge: "Local Guide",
      time: "5 weeks ago",
      rating: 5,
      text:
        "I have great credit and plenty of assets/money down. BUT my tax return showed a big old loss. Because of this my usual bank and a number of other banks wouldn't help me on a mortgage loan. JJ not only was able to get creative in order to get my approval, but was able to get me to my closing start to finish in under 3 weeks. He is THE guy.",
    },
    {
      author: "Pete O",
      badge: "Local Guide",
      time: "6 weeks ago",
      rating: 5,
      text:
        "JJ is hands down the best real estate professional we've ever worked with and will continue to work with him in the future. He answered any questions we had and made the home buying process a breeze. We didn't make it easy for him (we are VERY picky) but he sure made it easy for us. We definitely recommend working with JJ.",
    },
    {
      author: "A Fair",
      badge: null,
      time: "6 weeks ago",
      rating: 5,
      text:
        "I've used JJ for refinance, home selling, mortgage, and buying. There is no one I trust more to handle some of the biggest decisions of my life. Highly recommend.",
    },
    {
      author: "Evelynn M",
      badge: "Local Guide",
      time: "17 weeks ago",
      rating: 5,
      text:
        "My husband and I recently bought a house with the exceptional help of JJ! He worked tirelessly to get us the best deal we could find. He was always sure to explain everything in ways we could understand and happily answered any questions we had throughout the process. My husband and I really enjoyed having JJ by our side! Thank you for everything, JJ.",
    },
    {
      author: "Cole Maxwell",
      badge: "Local Guide",
      time: "17 weeks ago",
      rating: 5,
      text:
        "JJ and his team was incredibly helpful and kind. Couldn't have asked for a better customer service experience! 20/10 experience.",
    },
    {
      author: "Whitley Abney",
      badge: null,
      time: "33 weeks ago",
      rating: 5,
      text:
        "Great experience! 10/10 recommend for all your loan and real estate needs!",
    },
    {
      author: "Justin Dyess",
      badge: null,
      time: "40 weeks ago",
      rating: 5,
      text:
        "The best agent you will find, not only can he find you the perfect place, he can also get you the loan for it! Very responsive and stays on top of your real estate needs. Highly recommend!",
    },
    {
      author: "Cole Wyatt",
      badge: null,
      time: "40 weeks ago",
      rating: 5,
      text:
        "JJ did an awesome job helping us get the house and mortgage we needed to get into our dream house! He helped us overcome obstacles and was always there through every step. We highly recommend him to anyone!",
    },
    {
      author: "Joanna Peets",
      badge: null,
      time: "40 weeks ago",
      rating: 5,
      text:
        "JJ is by far the best Realtor. He takes the time to get you what you're looking for, he doesn't try to make a quick sale. I had questions about a few houses and he was texting me while he was on a cruise with his family. His love for people and customer satisfaction goes well beyond others. You don't just have a realtor when choosing JJ — you have a friend and someone who has your best interest in mind always.",
    },
    {
      author: "Ty Whaley",
      badge: null,
      time: "40 weeks ago",
      rating: 5,
      text:
        "JJ is an outstanding real estate professional who truly stands out in the industry. Knowledgeable, approachable, and always prepared, JJ brings a level of expertise and dedication that inspires confidence from the start. Whether it's understanding the local market, offering insightful guidance, or connecting clients with the right opportunities, JJ consistently goes above and beyond. If you're looking for someone who combines professionalism with genuine care and attention to detail, JJ is the person to call.",
    },
  ],
};

export const TESTIMONIALS = [
  {
    quote:
      "J.J. handled both the home search and the mortgage — start to finish, one calm voice. We closed two weeks early.",
    author: "The Hendersons",
    role: "Bought in Destin",
  },
  {
    quote:
      "Knew the Emerald Coast inside and out. Made selling our Niceville home feel almost easy. Easy 10/10.",
    author: "Marisol G.",
    role: "Sold in Niceville",
  },
  {
    quote:
      "Best rate, best service, no surprises. He picked up the phone every time. That's rare in mortgage.",
    author: "Daniel R.",
    role: "Refinanced in Fort Walton Beach",
  },
];
